import React, { HTMLAttributes, forwardRef } from 'react';
import './dimmer-content.css';

export type DimmerColor = 'black' | 'white' | 'transparent' | 'inherit';

export interface DimmerContentUIProps {
  uiColor?: DimmerColor;
}

export interface DimmerContentProps extends HTMLAttributes<HTMLDivElement>, DimmerContentUIProps {
  /** Optional: use class modifiers instead of data-attr */
  useClassMods?: boolean;
}

const DimmerContent = forwardRef<HTMLDivElement, DimmerContentProps>(
  ({ uiColor = 'black', useClassMods = false, className, ...rest }, ref) => {
    const base = 'dimmer-content';
    const classMod = useClassMods ? ` is-${uiColor}` : '';
    const finalClassName = [base + classMod, className].filter(Boolean).join(' ');
    const dataProps = useClassMods ? {} : { 'data-ui-color': uiColor };

    return <div ref={ref} className={finalClassName} {...dataProps} {...rest} />;
  }
);

export default DimmerContent;
